import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import FeatureFlagAPI from 'feature_flags/FeatureFlagAPI';

export const featureFlagKeys = {
  all: ['featureFlags'],
  user: () => [...featureFlagKeys.all, 'user'],
};

export function useFeatureFlags() {
  return useQuery({
    queryKey: featureFlagKeys.user(),
    queryFn: async () => {
      const response = await FeatureFlagAPI.getFeatureFlags();
      // Transform the array of feature objects into a more usable format
      const flags = {};
      if (response?.data?.user_feature_flags) {
        response.data.user_feature_flags.forEach(flag => {
          if (flag.feature === 'ai_coding') {
            flags.ai_coding = true;
          }
        });
      }
      return flags;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
}

export function useHasAICoding() {
  const { data: flags, isLoading } = useFeatureFlags();
  return {
    hasAICoding: flags?.ai_coding || false,
    isLoading
  };
}

export function useJoinBetaProgram(onSuccessCallback, onErrorCallback) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: () => FeatureFlagAPI.createFeatureFlag('ai_coding'),
    onSuccess: (response) => {
      // Transform and update the cache with the new feature flags
      const flags = {};
      if (response?.data?.user_feature_flags) {
        response.data.user_feature_flags.forEach(flag => {
          if (flag.feature === 'ai_coding') {
            flags.ai_coding = true;
          }
        });
      }
      
      queryClient.setQueryData(featureFlagKeys.user(), flags);

      // Call the UI callback if provided
      onSuccessCallback?.(response);
    },
    onError: (error) => {
      // Call the error callback if provided
      onErrorCallback?.(error);
    }
  });
}